import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../../server";
import { Button, Checkbox, Input, message, Popconfirm, Table } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { hasSubstring } from "../../../extensions/helper";
import Channel from "./channel";
import { dictsChannelVidName } from "../../../extensions/dicts";
import { RefreshButton } from "../../../extensions/design";
import { useSelector } from "react-redux";
import "./channels.css";

const Channels = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [filter, setFilter] = useState({ showHidden: false, searchText: "" });
  const divRef = useRef(null);
  const user = useSelector((s) => s.user);

  const getData = () => {
    if (!user?.companyId) return;
    setLoading(true);
    serverFetch("Message/Channel")
      .then((data) => {
        setItems(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(getData, [user?.companyId]);

  const columns = [
    { title: "#", dataIndex: "id", width: 70 },
    { title: "Наименование", dataIndex: "name", width: 180 },
    { title: "Код", dataIndex: "code", width: 120 },
    { title: "Вид", dataIndex: "vid", width: 140, render: dictsChannelVidName },
    { title: "Порядок", dataIndex: "idx", width: 80, align: "right" },
    { title: "Акт", dataIndex: "active", width: 48, align: "center", render: (v) => <Checkbox checked={v} disabled /> },
    {
      title: "",
      key: "delete",
      width: 48,
      align: "center",
      className: "channels-table-delete-cell",
      render: (_, record) => (
        <Popconfirm
          title="Удалить канал?"
          description="Это действие нельзя отменить."
          onConfirm={(e) => handleDelete(record, e)}
          onCancel={(e) => e?.stopPropagation()}
          okText="Да"
          cancelText="Нет"
        >
          <Button
            type="text"
            size="small"
            danger
            icon={<DeleteOutlined />}
            className="channels-table-delete-icon"
            onClick={(e) => e.stopPropagation()}
          />
        </Popconfirm>
      ),
    },
  ];

  const onClose = (refresh) => {
    setEditId();
    refresh && getData();
  };

  const handleDelete = (record, e) => {
    e?.stopPropagation();
    setLoading(true);
    serverFetch(`Message/Channel/${record.id}`, { method: "DELETE" })
      .then(() => getData())
      .catch((err) => {
        setLoading(false);
        message.error(err.userMessage);
      });
  };

  const headerSize = divRef.current?.querySelector(".ant-table-thead")?.offsetHeight ?? 0;
  const tableHeight = divRef.current
    ? document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY - 1
    : 0;
  const tableWidth = document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left || 0;

  const filtered = items.filter((item) => {
    if (!filter.showHidden && !item.active) return false;
    if (!hasSubstring(filter.searchText, item.name) && !hasSubstring(filter.searchText, item.code)) return false;
    return true;
  });

  return (
    <div>
      <div className="sport-form-title">
        <Checkbox
          checked={filter.showHidden}
          onChange={(e) => setFilter((prev) => ({ ...prev, showHidden: e.target.checked }))}
        >
          Показывать неактивные
        </Checkbox>
        <Input
          placeholder="Поиск"
          value={filter.searchText}
          onChange={(e) => setFilter((prev) => ({ ...prev, searchText: e.target.value }))}
          style={{ maxWidth: 200 }}
          allowClear
        />
        <Button type="primary" onClick={() => setEditId(0)}>
          Новый
        </Button>
        <RefreshButton onClick={getData} />
      </div>
      <div ref={divRef} style={{ width: tableWidth }}>
        <Table
          className="channels-table"
          dataSource={filtered}
          columns={columns}
          rowKey="id"
          loading={loading}
          size="small"
          pagination={false}
          scroll={{ y: tableHeight }}
          rowSelection={{
            type: "radio",
            selectedRowKeys: [editId],
            renderCell: (checked) => <div className={checked ? "list-indicator" : ""} />,
          }}
          onRow={(record) => ({ onClick: () => setEditId(record.id) })}
        />
      </div>
      {editId != null && (
        <Channel
          id={editId === 0 ? null : editId}
          onClose={onClose}
          companyId={user?.companyId}
        />
      )}
    </div>
  );
};

export default Channels;
